var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { space, layout, systemSxFromProps, } from '@revdotcom/vaporwave-system';
import { getCardSx } from '@revdotcom/vaporwave-sx';
import { forwardCommonProps } from '../Helpers/CommonProps';
var VaporwaveCard = function (_a) {
    var _b = _a.showHover, showHover = _b === void 0 ? false : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isSelectable, isSelectable = _d === void 0 ? false : _d, children = _a.children, rest = __rest(_a, ["showHover", "isSelected", "isSelectable", "children"]);
    return (_jsx("div", __assign({ sx: __assign(__assign({}, getCardSx(showHover, isSelected, isSelectable)), systemSxFromProps(rest, __spreadArray(__spreadArray([], space, true), layout, true))) }, forwardCommonProps(rest), { children: children })));
};
/**
 * Render a Card component. Card components stand out on a page and can contain any children.
 *
 * Cards are action-less components. To add user interaction to a Card, you will either need to
 * wrap the Card with another element, or have the interactive contents take up the full size of
 * the Card.
 *
 * The Card component uses both space and layout from styled-system. This means you can set
 * margin, padding, widths, heights, display type and more using styled-system properties.
 */
export var Card = VaporwaveCard;
